var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-flow"},[_c('div',{staticClass:"echart-progress"},[_c('el-progress',{attrs:{"type":"dashboard","percentage":_vm.usedFlow,"color":_vm.colors,"stroke-width":10}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }